import ReactGA from 'react-ga4'
import User from '@/types/User'
import { getOrCreateSessionToken } from '@/utils/qaSession'
import QuestionAnswer from '@/types/QuestionAnswer'

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

export function initGA() {
  if (!GA_MEASUREMENT_ID) return

  ReactGA.initialize(GA_MEASUREMENT_ID)
}

export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  ReactGA.event(eventName, params)
}

export function identifyUser(user?: User) {
  const userId = user ? String(user.id) : `anonymous_${getOrCreateSessionToken()}`
  ReactGA.gtag('set', { user_id: userId })
}

export function trackQuestionSubmittedEvent(questionAnswer: QuestionAnswer) {
  trackEvent('question_submitted', {
    id: questionAnswer.id,
    question: questionAnswer.question,
    answer: questionAnswer.answer,
  })
}
